<template>
    <CustomModal
        :is-modal-visible="addNewVisible"
        :modal-title="'Thêm mới cấu hình lịch đồng bộ cấp Trường'"
        :close-function="handleCloseModalAddNew"
        width="900px"
        :err-modal="errModal"
    >
        <template v-slot:content>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <label>Phường/Xã</label>
                    <ESelect
                        style="width: 100%"
                        :disabled="isRoleEducationOfficeOrSchool"
                        :data="list_ward"
                        :multiple="true"
                        :fields="['tenPhuongXa', 'maPhuongXa']"
                        v-model="ward"
                        @change="onChangeWard"
                        @input="onChangeHandler('ward', $event)"
                    />
                </div>
                <div class="col-md-4 mb-3">
                    <label>Cấp học</label>
                    <ESelect
                        style="width: 100%"
                        :data="list_grade_level"
                        :placeholder="'Chọn'"
                        :multiple="true"
                        :fields="['label', 'value']"
                        v-model="grade_level"
                        @change="onChangeGradeLevel"
                        @input="onChangeHandler('grade_level', $event)"
                    />
                </div>
                <div class="col-md-4 mb-3">
                    <label>Trường học <span class="error-label">*</span></label>
                    <ESelect
                        style="width: 100%"
                        :disabled="isRoleSchool"
                        :data="list_school"
                        :multiple="true"
                        :fields="['label', 'value']"
                        v-model="school"
                        @input="onChangeHandler('school', $event)"
                        :textError="err_school_label"
                    />
                </div>

                <div class="col-md-4">
                    <label>Thời gian nộp <span class="error-label">*</span>
                    </label>
                    <el-date-picker
                    style="width: 100%"
                        v-model="date"
                        type="daterange"
                        start-placeholder="Từ ngày"
                        end-placeholder="Đến ngày"
                        size="medium"
                        format="dd/MM/yyyy"
                        @change="onChangeDateRange"
                    >
                    </el-date-picker>
                    <span
                        v-if="err_start_date.length > 0 || err_end_date.length > 0"
                        class="text-error-select"
                    >
                        {{ err_start_date || err_end_date }}
                    </span>
                </div>
            </div>
                
        </template>

        <template v-slot:btn-handle>
            <CustomButton label="Lưu" @click="handleAddNew" />
        </template>
    </CustomModal>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomModal from '@/components/CustomModal.vue'
import { showNotication } from '@/utils/notification'
import { formatDateToDDMMYYYY, convertListData } from '@/utils'
import ESelect from '@/components/ESelect.vue'
import { validateFields, handlerError } from '@/utils/validator'
import { ROLES, checkUserRole } from '@/constants/Roles'
export default {
    name: 'ModalAdd',
    data() {
        return {
            ward: [],
            list_ward: [],
            grade_level: [],
            list_school: [],
            school: [],
            date: '',
            start_date: '',
            end_date: '',

            err_school_label: '',
            err_end_date: '',
            err_start_date: '',
            errModal: false
        }
    },
    props: {
        addNewVisible: {
            type: Boolean,
            required: true
        },
        closeModalAddNew: Function,
        handleSearch: Function
    },
    components: { CustomButton, CustomModal, ESelect },
    methods: {
        async get_list_ward() {
            try {
                const request_data = {
                    start: 0,
                    limit: 9999,
                    maTinhThanh: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore
                }

                const response = await sendRequest(
                    Api.app.phuong_xa,
                    null, // GET request uses params, not data
                    this.request_headers,
                    request_data // params for GET request
                )

                this.list_ward = response.rows || []
                
                // After loading wards, pre-select based on ma_don_vi if applicable
                if (this.isRoleEducationOfficeOrSchool && this.auth_user?.ma_don_vi) {
                    this.preselectWardFromMaDonVi(this.auth_user.ma_don_vi)
                }
            } catch (error) {
                console.log(error)
                this.list_ward = []
            }
        },
        
        /**
         * Pre-select ward based on ma_don_vi
         */
        preselectWardFromMaDonVi(ma_don_vi) {
            if (!ma_don_vi || !this.list_ward || this.list_ward.length === 0) {
                return
            }
            
            // Find ward where maPhuongXa matches ma_don_vi
            const foundWard = this.list_ward.find(
                (ward) => ward.maPhuongXa === ma_don_vi || ward.maPhuongXa === String(ma_don_vi)
            )
            
            if (foundWard) {
                // Pre-select the ward (as array since it's multiple select)
                this.ward = [foundWard.maPhuongXa]
                // Trigger school list update if ward is pre-selected
                this.get_list_school()
            }
        },

        async get_list_school() {
            const request_data = {
                capHoc: this.grade_level,
                maPhuongXaList: this.ward || [],
                namHoc: this.selectedYearFromStore
            }

            const response = await sendRequest(
                Api.internal_api.dm_School,
                request_data,
                this.request_headers,
                null
            )
            this.list_school = convertListData(
                response.rows,
                'tenTruongHoc',
                'maTruongHoc'
            )
        },
        resetSchool() {
            this.school = []
            this.err_school_label = ''
            this.get_list_school()
        },
        onChangeWard() {
            this.resetSchool()
        },
        onChangeGradeLevel() {
            this.resetSchool()
        },

        onChangeDateRange(value) {
            if (value && value.length === 2) {
                this.start_date = value[0]
                this.end_date = value[1]
                this.onChangeHandler('start_date', value[0])
                this.onChangeHandler('end_date', value[1])
            } else {
                this.start_date = ''
                this.end_date = ''
                this.err_start_date = ''
                this.err_end_date = ''
                this.errModal = false
            }
        },
        onChangeHandler(source, newValue) {
            const noValidate = ['grade_level', 'ward']

            if (noValidate.includes(source) && newValue.length > 0) {
                this.errModal = true
            } else {
                this.errModal = false
            }

            const errorFields = {
                school: 'err_school_label',
                start_date: 'err_start_date',
                end_date: 'err_end_date'
            }

            handlerError(this, source, newValue, errorFields)

            this.errModal = !!newValue
        },
        handleClearData() {
            this.ward = []
            this.grade_level = []
            this.school = []
            this.errModal = false
            this.err_school_label = ''
            this.date = ''
            this.start_date = ''
            this.err_start_date = ''
            this.end_date = ''
            this.err_end_date = ''
        },
        handleCloseModalAddNew() {
            this.closeModalAddNew()
            this.handleClearData()
        },
        async handleAddNew() {
            // Đồng bộ từ date range (v-model) sang start_date/end_date trước khi validate
            if (this.date && Array.isArray(this.date) && this.date.length === 2) {
                this.start_date = this.date[0]
                this.end_date = this.date[1]
            }
            const fieldsToValidate = [
                {
                    value: this.school,
                    errorField: 'err_school_label'
                },
                {
                    value: this.start_date,
                    errorField: 'err_start_date'
                },
                {
                    value: this.end_date,
                    errorField: 'err_end_date'
                }
            ]
            if (validateFields(this, fieldsToValidate)) {
                const request_data = {
                    ngayBatDau: formatDateToDDMMYYYY(this.start_date),
                    ngayKetThuc: formatDateToDDMMYYYY(this.end_date),
                    dsMaTruong: this.school,
                    maSo: this.auth_user.ma_so,
                    namHoc: this.selectedYearFromStore
                }
                try {
                    const response = await sendRequest(
                        Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo
                            .them_moi_ngay_cap_truong,
                        request_data,
                        this.request_headers
                    )
                    if (response.rc == 0) {
                        showNotication(this, 'success', 'Thêm mới thành công', {
                            customClass: 'notification-unlock'
                        })
                        this.handleCloseModalAddNew()
                        this.$emit('handleSearch')
                    } else {
                        showNotication(this, 'warning', 'Trường đã tồn tại cấu hình', {
                            customClass: 'notification-lock'
                        })
                    }
                } catch (error) {
                    if (error.response?.data.rd) {
                        showNotication(this, 'error', error.response?.data.rd)
                    }
                }
            }
        }
    },
    mounted() {
        this.get_list_ward()
        this.get_list_school()
    },
    watch: {
        auth_user: {
            handler(user) {
                if (this.isRoleEducationOfficeOrSchool) {
                    this.unit_education = user.ma_phong ? [user.ma_phong] : []
                    // Pre-select ward based on ma_don_vi
                    this.preselectWardFromMaDonVi(user.ma_don_vi)
                }
                if (this.isRoleSchool) {
                    this.school = user.ma_truong_hoc ? [user.ma_truong_hoc] : []
                }
            },
            immediate: true
        },
        list_ward: {
            handler(newList) {
                // When ward list is loaded, try to pre-select based on ma_don_vi
                if (newList && newList.length > 0 && this.isRoleEducationOfficeOrSchool) {
                    const user = this.auth_user
                    if (user && user.ma_don_vi) {
                        this.preselectWardFromMaDonVi(user.ma_don_vi)
                    }
                }
            },
            immediate: false
        }
    },
    computed: {
        list_unit_education() {
            return getFromSessionStorage('list_unit_education')
        },
        list_grade_level() {
            return getFromSessionStorage('list_grade_level')
        },
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },

        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        isRoleEducationOfficeOrSchool() {
            return (
                checkUserRole(this.auth_user, ROLES.EducationOffice) ||
                checkUserRole(this.auth_user, ROLES.School)
            )
        },
        isRoleSchool() {
            return checkUserRole(this.auth_user, ROLES.School)
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
::v-deep .el-input__inner {
    border: 1px solid #b2b7bd;
}
::v-deep .el-input__inner {
    color: #373333;
}

::v-deep .el-input__inner:focus {
    border: 1px solid #007bff;
    box-shadow: #b2b7bd;
}

.el-date-table td.start-date span,
.el-date-table td.end-date span {
    background-color: var(--blue-200);
}
.el-date-table td.today span,
.el-date-table td.available:hover {
    color: var(--blue-200);
}
</style>
